<template>
  <div>
    <template v-if="$route.name == 'privacy-policy'">
      <b-container>
          <h2 class="heading">Privacy Policy</h2>
          <p>
            Last Updated: October 20, 2025
          </p>
           <span class="boldText"> 1. Introduction</span>
           <p>

            MENA Golf Tour FZCO, a company registered in the United Arab Emirates under license number L-4127, is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard the personal data of EU residents under the General Data Protection Regulation (GDPR) in connection with our golf tournaments in Portugal.

            For any queries, contact our Data Protection Contact at keith@menagolftour.com. As a small-scale operation with potentially one-off events in the EU, we rely on the Article 27(2) exemption from appointing an EU representative, but we remain fully compliant with GDPR.
           </p>

            <span class="boldText">2. Data We Collect</span>

            <p>We collect only the minimal data necessary for tournament operations:

            Name, email, phone, address, and payment details (processed via our website application).
            Photos (with your consent).

            Data is obtained directly from you during registration or from public sources (e.g., event photos).
            </p>

            <span class="boldText">3. Lawful Bases and Purposes</span>

            <p>We process your data based on the following lawful bases:

            Contract: To register and manage your participation in tournaments.
            Legitimate Interests: For event organization and security purposes.
            Consent: For marketing, updates, and photo usage (you may withdraw consent anytime by emailing keith@menagolftour.com.

            Processing is limited to these purposes, and we delete data when no longer needed (e.g., after the event).
            </p>

            <span class="boldText">4. Sharing and Transfers</span>

            <p>We share your data with processors, such as Tap Payments in the UAE, for payment processing. All processors are bound by Data Processing Agreements. Transfers to the UAE, a non-adequate country, are protected by EU Standard Contractual Clauses (SCCs). We do not sell your data.</p>

            <span class="boldText">5. Your Rights</span>

            <p>Under GDPR, you have the following rights:

            Access, rectify, erase, restrict, object to, or request portability of your data.
            Submit requests to keith@menagolftour.com; we will respond within 1 month.
            Lodge complaints with the Comissão Nacional de Proteção de Dados (CNPD) in Portugal at www.cnpd.pt.</p>

            <span class="boldText">6. Security and Breaches</span>

            <p>We implement encryption, access controls, and secure servers to protect your data. In the event of a breach, we will notify the CNPD within 72 hours and affected individuals if there is a high risk.</p>

            <span class="boldText">7. Changes to This Policy</span>

            <p>We may update this Privacy Policy periodically. Please check back regularly for changes. For questions, contact us at keith@menagolftour.com. </p>

            <span class="boldText">8. Acknowledgment</span>

            <p>By using our services, you acknowledge and agree to the terms of this Privacy Policy.</p>

      </b-container>
    </template>
    <template v-else>
      <div class="paddingBottom">
        <img :src="pageData[0].better_featured_image.source_url">
        <b-container>
          <h2 class="heading" v-html="pageData[0].title.rendered"></h2>
          <p v-html="pageData[0].content.rendered"></p>
        </b-container>
        <div class="bkBlack">
          <b-container>
            <b-row>
              <b-col lg="6" sm="12">
                <img class="img" src="https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/our-vision.jpg">
              </b-col>
              <b-col lg="6" sm="12">
                <div class="postSection">
                  <h2 class="headingPost">Our Vision</h2>
                  <p class="textPost">
                    To be the most compelling professional development tour in the <br>
                    world — the launchpad where tomorrow’s champions sharpen <br>
                    their skills, embrace the grind and ignite their careers.
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="whiteCon">
          <b-container>
            <b-row>
              <b-col lg="6" sm="12">
                <div class="postSection">
                  <h2 class="headingPost">Our Mission</h2>
                  <p class="textPost black">
                  We’re building a bold, modern platform for emerging pros — infused with creativity, edge and authenticity. 
                  This isn’t about mimicking the big tours. It’s about showing exactly what it takes to get there: the hustle, 
                  the heartbreak and the breakthrough moments that change everything. We are attracting new fans, 
                  fresh partners and creating a proving ground for both talent and creativity.
                  <br>
                  <br>
                  This is the MENA Golf Tour. Raw. Real. Relentless. Ready to shape the next Robert MacIntyre.
                  </p>
                </div>
              </b-col>
              <b-col lg="6" sm="12">
                <img class="img" src="https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/RANGEBALLS.jpg">
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "single",
  props: ["id"],
  components: {
  },
  data() {
    return {
      pageData: [],
    };
  },
  mounted() {
    axios //add API Call
      .get(
        process.env.VUE_APP_WPAPI_URL+"wp/v2/pages?slug=" +
          this.$route.name + "&randomadd=" +
              new Date().getTime()
      ) // Page number changed on each page based on JSON page id you are calling
      .then((response) => {
        this.pageData = response.data;
      });
  },
};
</script>

<style scoped>
@font-face {
	font-family: 'Grift-Bold'!important;
	font-weight: normal;
	font-style: normal;
	/* src: url('https://wp-mena.ocs-software.com/wp-content/themes/wp-bootstrap-starter/fonts/Grift-Regular.ttf'); */
	src: url('https://wp-mena.ocs-software.com/wp-content/themes/wp-bootstrap-starter/fonts/Grift-Bold.ttf')!important;
}
span.boldText {
  font-weight: bold;
  /* padding-bottom: 20px; */
  margin-bottom: 20px;
  display: block;
  font-family: 'Grift-Bold', sans-serif;
}
.postSection {
  margin-top: 8%;
}
img {
  width: 100%;
}
.black {
  color: #152229!important;
}
.bkBlack {
 background-color: #152229; 
 padding: 3%;
 margin-top: 50px;
}
.whiteCon {
 padding: 3%;
 margin-top: 50px;
}
.heading {
  font-weight: 600;
  font-size: 40px;
  color: #c8102e;
  padding-top: 40px;
  padding-bottom: 40px;
}
.paddingBottom {
  padding-bottom: 50px;
}
h2.headingPost {
  font-weight: 600;
  font-size: 30px;
  color: #c8102e;
  padding-top: 40px;
  padding-bottom: 40px;
}
p.textPost {
  font-size: 20px;
  color: #ffff;
}
@media only screen and (max-width: 510px) {
  h2.headingPost {
    font-weight: 600;
    font-size: 30px;
    color: #c8102e;
    padding-top: 0px;
    padding-bottom: 20px;
  }
  .whiteCon {
    padding: 3%;
    margin-top: 0px;
  }
}
</style>
